import Axios, { AxiosResponse } from 'axios';
import { config } from '../../../config';
import { RankingsApiParams } from '../../../typings/api';
import RANKING_YEAR_TRANSITIONS from '../constants';

const getRankingYear = (discipline: string): number => {
  const now = new Date();
  const transition = RANKING_YEAR_TRANSITIONS[discipline] || RANKING_YEAR_TRANSITIONS.DEFAULT;

  if (transition === RANKING_YEAR_TRANSITIONS.DEFAULT) {
    return now.getFullYear();
  }

  const { month, day } = transition;
  const transitionDate = new Date(now.getFullYear(), month - 1, day);

  return now >= transitionDate ? now.getFullYear() + 1 : now.getFullYear();
};

// eslint-disable-next-line import/prefer-default-export
export const getRankings = async ({
  discipline,
  category,
  type,
  id,
}: RankingsApiParams) => {
  const currentYear = getRankingYear(discipline ?? 'DEFAULT');
  const { data }: AxiosResponse = await Axios.get(
    `${config.apiUrl}/rankings/details?DisciplineCode=${discipline}&SeasonYear=${currentYear}&Category=${category}&rankingType=${type}&rankingId=${id}`,
  );

  return data;
};

export const getTechnicalRankings = async () => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/rankings/technical`);

  return data;
};
